import { NotFoundComponent } from './../../shared/components/notFound/not-found.component';
import { AuthGuard } from '../../shared/guards/authGuard/auth.guard';
import { MainFrameModule } from './../mainframe/mainframe.module';
import { RolComponent } from './rol.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  { path: '', component: RolComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RolRoutingModule { }
